// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1Oulg","overflowing":"ReadFullNote_overflowing__14EbU"};